import { useNavigate as useAppBridgeNavigate } from '@shopify/app-bridge-react';

export const useNavigate = () => {
  const embedded = typeof window !== 'undefined' && window.self !== window.top;
  const navigate = embedded
    ? useAppBridgeNavigate()
    : (path) => window.location.assign(path);

  return navigate;
};
